import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'how_often_has_the_grievance_mechanism_been_used_in_the_assessme'

export const dataPointDefinition = {
  retracedId: 'how_often_has_the_grievance_mechanism_been_used_in_the_assessme',
  name: 'How often has the grievance mechanism been used in the assessment period?',
  description: 'Please provide the number of registered complaints within the assessment timeframe.',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wi-gri-11',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 12890,
  sectionId: '2.2.10',
  impactArea: 'Social Dialogue, Grievance Mechanisms and Disputes',
  impactAreaId: 'COMPLAINT_AND_GRIEVANCE_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
